import { Button, BUTTON_THEME, Chip, CHIP_TYPES, Icon } from '@st-operations/uikit/src/v2'
import React, { useState, useMemo } from 'react'
import { useEffect } from 'react'

import MultiValueInput from '_components/multi-value-input/index.jsx'
import { getGeoCountryStatistics } from '_services/data-explorer'
import useTotalUsers from '../hooks/useTotalUsers.js'
import geoIsoValues from '../../../../constants/geos.json'
import MonthlyUserCount from '../monthly-user-count/index.jsx'

import './styles.scss'

const EventFeedsWizardGeo = ({
  onBackClick,
  geos,
  onGeosChange,
  onSkip,
  onAddGeos,
  cumulativeFilters,
  onCumulativeFiltersChange,
}) => {
  const payload = useMemo(() => {
    const withoutGeos = cumulativeFilters.filter((f) => f.key !== 'geo_iso')
    return geos?.length > 0
      ? { filters: [...withoutGeos, { key: 'geo_iso', operator: 'in', value: geos }] }
      : { filters: [...withoutGeos] }
  }, [geos])
  const [totalUsers] = useTotalUsers(payload)

  useEffect(() => {
    if (onCumulativeFiltersChange) {
      onCumulativeFiltersChange(payload.filters)
    }
  }, [payload])

  const [suggestedCountries, setSuggestedCountries] = useState([])

  useEffect(() => {
    const requestConfig = { filters: [] }
    getGeoCountryStatistics(requestConfig).then(({ countries }) => {
      setSuggestedCountries(Object.values(countries).filter((c, index) => index < 10))
    })
  }, [])

  const handleAddSuggestedCountry = (countryId) => {
    onGeosChange([...new Set([...geos, countryId])])
  }

  return (
    <div className="event-feeds-wizard-geo__container">
      <Button
        theme={BUTTON_THEME.GHOST}
        onClick={onBackClick}
        className="event-feeds-wizard-geo__back-button"
      >
        <Icon type="outline" icon="angleleft" />
        Back
      </Button>
      <span className="event-feeds-wizard-geo__title">{`4. I'm interested in these geos:`}</span>
      <MultiValueInput
        name="value"
        className="event-feeds-wizard-geo__input"
        values={geos}
        onChange={(value) => {
          onGeosChange(value)
        }}
        options={geoIsoValues
          .filter((f) => f.value !== 'GLOBAL')
          .sort((s1, s2) => (s1.label > s2.label ? 1 : -1))}
      />
      <div className="event-feeds-wizard-geo__suggested">
        <div className="event-feeds-wizard-geo__suggested-title">Suggested Geos</div>
        <div className="event-feeds-wizard-geo__suggested-countries-container">
          <For
            each="suggestedCountry"
            of={Object.values(suggestedCountries).filter((sc) => !geos.includes(sc.id))}
          >
            <Chip
              key={suggestedCountry.id}
              value={suggestedCountry.name}
              onClick={() => handleAddSuggestedCountry(suggestedCountry.id)}
              onButtonClick={() => handleAddSuggestedCountry(suggestedCountry.id)}
              small
              hasAddIcon
              type={CHIP_TYPES.FILL}
            />
          </For>
        </div>
      </div>
      <MonthlyUserCount totalUsers={totalUsers} />
      <Button theme={BUTTON_THEME.GHOST} onClick={onSkip}>
        Skip
      </Button>
      <div className="event-feeds-wizard-geo__add-terms-container">
        <Button
          className="event-feeds-wizard-geo__add-terms-button"
          disabled={geos.length === 0}
          onClick={onAddGeos}
        >
          Add Geo
        </Button>
      </div>
    </div>
  )
}

export default EventFeedsWizardGeo
